var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userPermissions.indexOf("ecp_bonus")>-1)?_c('el-tabs',{staticClass:"performance-tab",attrs:{"tab-position":_vm.tabPosition}},[_c('TeamBonus')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }